import React, { useEffect, useRef } from 'react';
import handleNumericCheck from "../../../utils/HandleNumericKeys";
import { useState } from 'react';
import isNull from '../../../utils/NullChecking';
import NotificationHandler from '../../../utils/NotificationHandler';
import { enumUtil } from '../../../utils/Enum';
import SuperSearchList from '../SuperSearch/SuperSearchList';
import { useSelector } from 'react-redux';

function Pagination(props) {
    const [arrOfCurrentButtons, setArrOfCurrentButtons] = useState([]);
    const [goToPage, setGoToPage] = useState('');
    let SetupTabsData = useSelector(state => state.SetupActiveTabReducer);
    let SidebarActive = useSelector(state => state.SidebarActiveTab);
    let SubmissionActiveTab = useSelector(state => state.MainBarActiveTabsReducer?.Submission?.ActiveTabKey);
    let EdiReportsActiveTab = useSelector(state => state.MainBarActiveTabsReducer?.['EDI Reports']?.ActiveTabKey);
    let RealTime = useSelector(state => state.MainBarActiveTabsReducer?.Realtime?.ActiveTabKey);
    let AccReceivables = useSelector(state => state.MainBarActiveTabsReducer?.['Account Receivables']?.ActiveTabKey);
    let DataImport = useSelector(state => state.MainBarActiveTabsReducer?.DataImport?.ActiveTabKey);
    let Monitoring = useSelector(state => state.MainBarActiveTabsReducer?.Monitoring?.ActiveTabKey);
    let StatementActiveTab = useSelector(state => state.MainBarActiveTabsReducer?.Statements?.ActiveTabKey);
    let ReportsTab = useSelector(state => state.Open_Report_Tab);
    const reportsTabRef = useRef(ReportsTab);
    const SidebarActiveTab = useRef(SidebarActive);

    useEffect(() => {
        reportsTabRef.current = ReportsTab;
        SidebarActiveTab.current = SidebarActive;

    }, [ReportsTab, SidebarActive]);
    const ShowingPages = [
        { value: '10', display: '10' },
        { value: '20', display: '20' },
        { value: '50', display: '50' },
        { value: '100', display: '100' },
        { value: '500', display: '500' },
        { value: '1000', display: '1000' },
    ];
    const ShowingPages2 = [
        { value: '10', display: '10' },
        { value: '20', display: '20' },
        { value: '50', display: '50' },
        { value: '100', display: '100' },
        { value: '500', display: '500' },
        { value: '1000', display: '1000' },
        { value: '2000', display: '2000' },
        { value: '5000', display: '5000' },
    ];
    const ShowingPages500 = [
        { value: '10', display: '10' },
        { value: '20', display: '20' },
        { value: '50', display: '50' },
        { value: '100', display: '100' },
        { value: '500', display: '500' },
    ];
    const [OptionsDD, setOptionsDD] = useState(
        props.RowsDD === '2' ? ShowingPages2 :
            props.RowsDD === '500' ? ShowingPages500 :
                ShowingPages)
    let numberOfPages = [];
    for (let i = 1; i <= props.TotalPages; i++) {
        numberOfPages.push(i);
    }
    const paginationn = () => {
        let tempNumberOfPages = [...arrOfCurrentButtons];
        let dotsInitial = '...';
        let dotsLeft = '... ';
        let dotsRight = ' ...';

        if (numberOfPages.length < 6) {
            tempNumberOfPages = numberOfPages;
        } else if (props.PageNo >= 1 && props.PageNo < 3) {
            tempNumberOfPages = [1, 2, 3, dotsInitial, numberOfPages.length];
        } else if (props.PageNo >= 2 && props.PageNo <= 3) {
            tempNumberOfPages = [2, 3, 4, dotsInitial, numberOfPages.length];
        } else if (props.PageNo === 4) {
            const sliced = numberOfPages.slice(2, 5);
            tempNumberOfPages = [...sliced, dotsInitial, numberOfPages.length];
        } else if (props.PageNo > 4 && props.PageNo < numberOfPages.length - 2) {
            const sliced1 = numberOfPages.slice(props.PageNo - 2, props.PageNo);
            const sliced2 = numberOfPages.slice(props.PageNo, props.PageNo + 1);
            tempNumberOfPages = ([1, dotsLeft, ...sliced1, ...sliced2, dotsRight, numberOfPages.length]);
        } else if (props.PageNo > numberOfPages.length - 3) {
            const sliced = numberOfPages.slice(numberOfPages.length - 3);
            tempNumberOfPages = ([1, dotsLeft, ...sliced]);
        }

        setArrOfCurrentButtons(tempNumberOfPages);
    };
    useEffect(() => {
        paginationn();
    }, [props.PerPage, props.PageNo, props.TotalPages]);
    const handleDotClick = (item) => {
        if (item === '...') {
            props.handlePageClick(arrOfCurrentButtons[arrOfCurrentButtons.length - 3] + 1);
        } else if (item === ' ...') {
            props.handlePageClick(arrOfCurrentButtons[3] + 2);
        }
        else if (item === '... ') {
            props.handlePageClick(arrOfCurrentButtons[3] - 2);
        }
    };
    const SelectedRecords = () => {
        if (props.selectedRows && props.selectedRows.size > 0) {
            if (props.selectedRows.size === 1) {
                return '1 Record Selected'
            } else {
                return props.selectedRows.size + ' Record(s) Selected'
            }
        }
    }
    const handleSelect = (data) => {
        props.handleSelectData(data)
    }
    // const handleLoadRef = useRef(props.LoadData);
    // Update ref to latest handleSave whenever it changes
    // useEffect(() => {
    //     handleLoadRef.current = props.LoadData;
    // }, [props.LoadData]);
    const isInputFocused = () => {
        const activeElement = document.activeElement;
        return (
            activeElement.tagName === 'INPUT' ||
            activeElement.tagName === 'TEXTAREA' ||
            activeElement.tagName === 'SELECT' ||
            activeElement.isContentEditable
        );
    };
    useEffect(() => {
        let lastKeyPressTime = 0;
        let firstKey = '';
        let combinationTimer = null;

        const handleKeyDown = (event) => {
            const currentKey = event.key.toLowerCase();

            if (isInputFocused()) {
                // Reset if user is typing in input
                firstKey = '';
                lastKeyPressTime = 0;
                clearTimeout(combinationTimer);
                return;
            }

            // Check for valid first keys (S or C)
            if ((currentKey === 's' || currentKey === 'c') && firstKey === '') {
                // event.preventDefault();
                // event.stopPropagation();

                firstKey = currentKey;
                lastKeyPressTime = Date.now();

                // Set timeout to reset if no second key within 500ms
                combinationTimer = setTimeout(() => {
                    firstKey = '';
                    lastKeyPressTime = 0;
                }, 500);

                return;
            }

            // Check for second key to complete combination
            if (firstKey !== '' && (currentKey === 'r' || currentKey === 's')) {
                const currentTime = Date.now();

                // Check if second key pressed within 500ms
                if (currentTime - lastKeyPressTime < 500) {
                    // event.preventDefault();
                    // event.stopPropagation();

                    const shouldExecute = checkTabConditions(SidebarActiveTab.current, props.Key);

                    if (shouldExecute) {
                        // S + R combination → Load Data
                        if (firstKey === 's' && currentKey === 'r' && props.LoadData) {
                            console.log('S+R pressed - executing LoadData');
                            props.LoadData();
                        }
                        // C + S combination → Clear Search  
                        else if (firstKey === 'c' && currentKey === 's' && props.ClearSearch) {
                            console.log('C+S pressed - executing ClearSearch');
                            props.ClearSearch();
                        }
                    }
                }

                // Reset after handling combination
                firstKey = '';
                lastKeyPressTime = 0;
                clearTimeout(combinationTimer);
            } else {
                // Reset if invalid key combination
                firstKey = '';
                lastKeyPressTime = 0;
                clearTimeout(combinationTimer);
            }
        };

        // Helper function to check tab conditions
        const checkTabConditions = (activeTab, componentKey) => {
            switch (activeTab) {
                case 5:                                                                                     // Setup tab
                    const activeTabData = SetupTabsData.find(tab => tab.active);
                    if (!activeTabData) return false;
                    const activeSubMenu = activeTabData.subMenu.find(subItem => subItem.active);
                    return activeSubMenu && activeSubMenu.key === componentKey;
                case 71:                                                                                    // Claims search
                case 2:                                                                                     // Patient search
                case 73:                                                                                    // Payment search
                case 15:                                                                                    // Support
                case 12:                                                                                    // Task      
                case 77:                                                                                    // Billing => Documents                                   
                    return true;                                                                            // Always execute for these tabs
                case 72:                                                                                    // Submission search
                    return SubmissionActiveTab === componentKey;
                case 78:
                    return EdiReportsActiveTab === componentKey;
                case 74:                                                                                    // RealTime search 
                    return RealTime === componentKey;
                case 75:
                    // AccReceivables search 
                    return AccReceivables === componentKey;
                case 76:                                                                                    // Statement search 
                    return StatementActiveTab === componentKey;
                case 4:
                    const latestReports = reportsTabRef.current; // ✅ always latest value
                    const ReportsActiveTab = latestReports?.find((re) => re.active);
                    return ReportsActiveTab?.data?.id === componentKey;
                case 81:                                                                                    // Data Import
                    return DataImport === componentKey
                case 82:                                                                                    // Monitoring Tab
                    return Monitoring === componentKey
                default:
                    return false;
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [SetupTabsData, SidebarActiveTab, props.Key, props.LoadData, props.ClearSearch, ReportsTab]);
    return (
        <>
            <div className='grid-pagination align-items-center'>
                <div className='d-flex justify-content-between align-items-center col-md-6'>
                    <div className='row-per-page'>
                        <p className='text-nowrap'>Rows per page</p>
                        {isNull(props.handleSelectData) ?
                            <select
                                value={props.PerPage}
                                onChange={props.handleFingByCreteria}>
                                {OptionsDD && OptionsDD.map((type) => {
                                    return (
                                        <option value={type.value} key={type.value}>{type.display}</option>
                                    );
                                })}
                            </select> :
                            <div className="ar-pagnation-search">
                                <SuperSearchList
                                    type="client"
                                    id='PerPage'
                                    name='PerPage'
                                    searchValue={props.PerPage}
                                    data={OptionsDD}
                                    onChange={props.handleFingByCreteria}
                                    getSelectedData={handleSelect}
                                    is={props.is}
                                    icon={'Simple'}
                                    sup_btn='sup_btn'
                                    sup_inp='superSearchVisitInp'
                                    ScrollOutside={true}
                                    disableInput={true}
                                />
                            </div>
                        }
                    </div>
                    <span className="text ar-found-text fw-400 fst-italic">{SelectedRecords()}</span>
                    <span className="text ar-found-text fw-400 fst-italic">{props.Counts ? props.Counts + ' Record(s) Found' : null} </span>
                </div>
                <div className='d-flex align-items-stretch gap-10 flex-wrap'>
                    <div className='pagination'>
                        <button className={props.PageNo === 1 ? "page-nav left disabled" : "page-nav left"}>
                            <i className='icon-angle-right' onClick={() => props.PreviousPage()}></i>
                        </button>
                        <ul>
                            {arrOfCurrentButtons.map((item, index) => {
                                return (
                                    <li
                                        className={item === props.PageNo ? 'active' : ''}
                                        key={index}
                                        onClick={() => {
                                            if (item !== '...' && item !== ' ...' && item !== '... ') {
                                                props.handlePageClick(item);
                                            } else {
                                                handleDotClick(item);
                                            }
                                        }}
                                    >
                                        {item}
                                    </li>
                                );
                            })}
                        </ul>
                        <button className={props.PageNo + "" === props.TotalPages + "" ? "page-nav right disabled" : "page-nav right"}>
                            <i className='icon-angle-right' onClick={() => props.NextPage()}></i>
                        </button>
                    </div>
                    <div className='go-to-page'>
                        <p>Go to page</p>
                        <input type="text" value={goToPage} onChange={(e) => setGoToPage(e.target.value)} onKeyPress={(event) => handleNumericCheck(event)} />
                        <button>
                            <i className='icon-Group-2424' onClick={() => { isNull(goToPage) ? NotificationHandler('Enter page number', enumUtil.enumtoaster.error) : props.handlePageClick(goToPage - "") }}></i>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Pagination;
